import React from "react";
import frame24 from "../../images/Frame 24.svg";
import step1 from "../../images/Frame 14.svg";
import step2 from "../../images/Frame 14 (1).svg";
import step3 from "../../images/Frame 14 (2).svg";

const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const STEPS = [
	{
		num: "01",
		title: "Download the App",
		desc: "Get the Zikora App on Google Play or App Store.",
	},
	{
		num: "02",
		title: "Enter your Details",
		desc: "Provide your phone number, BVN, and basic information securely.",
	},
	{
		num: "03",
		title: "Start Banking",
		desc: "Fund your account, transfer money, save, and access services instantly.",
	},
];

const HowItWorks = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.hiw-desktop { display: none !important; }
					.hiw-mobile  { display: block !important; }
					.hiw-section {
						padding: 60px 24px !important;
						display: flex !important;
						flex-direction: column !important;
						align-items: center !important;
					}
					.hiw-card-outer {
						width: 342px !important;
						height: 522px !important;
						border-radius: 8px !important;
						min-height: unset !important;
						margin: 0 !important;
						position: relative !important;
						overflow: hidden !important;
					}
					.hiw-mobile {
						width: 100%;
						height: 100%;
					}
				}
				.hiw-mobile { display: none; }
			`}</style>

			<section
				className="hiw-section"
				style={{
					width: "100%",
					backgroundColor: "#FFFFFF",
					boxSizing: "border-box",
					padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
				}}
			>
				<div
					className="hiw-card-outer"
					style={{
						maxWidth: "1280px",
						margin: "0 auto",
						backgroundColor: "#132A22",
						borderRadius: "16px",
						boxSizing: "border-box",
						minHeight: "464px",
					}}
				>
					{/* ── DESKTOP layout ── */}
					<div
						className="hiw-desktop"
						style={{
							paddingTop: "80px",
							paddingBottom: "80px",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "18px",
						}}
					>
						{/* Label + Heading */}
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "8px",
							}}
						>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", height: "32px" }}>
								<span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#86C7A8", flexShrink: 0, display: "inline-block" }} />
								<span
									style={{
										fontFamily: "'Geist Mono', monospace",
										fontWeight: 500,
										fontSize: "14px",
										lineHeight: "32px",
										letterSpacing: "0.08em",
										color: "#86C7A8",
										textTransform: "uppercase",
									}}
								>
									Quick Onboarding
								</span>
							</div>

							<h2
								style={{
									...instrumentSerif,
									fontWeight: 400,
									fontSize: "clamp(28px, 3.47vw, 50px)",
									lineHeight: "1.1",
									letterSpacing: "-0.01em",
									color: "#FFFFFF",
									margin: 0,
									textAlign: "center",
									whiteSpace: "nowrap",
								}}
							>
								Open your Zikora MFB account in 3 easy steps...
							</h2>
						</div>

						{/* Steps */}
						<div style={{ width: "min(1049px, 88%)", display: "flex", flexDirection: "column", gap: "clamp(16px, 2.22vw, 32px)" }}>
							<img
								src={frame24}
								alt="Step numbers 1, 2, 3"
								style={{
									width: "min(788px, 75.1%)",
									height: "auto",
									display: "block",
									flexShrink: 0,
									marginLeft: "clamp(0px, 9.24vw, 133px)",
								}}
							/>
							<div style={{ display: "flex", gap: "clamp(16px, 4.58vw, 66px)", alignItems: "flex-start" }}>
								<img src={step1} alt="Step 1: Download the Zikora MFB app" style={{ flex: 1, minWidth: 0, maxWidth: "305px", height: "auto", display: "block" }} />
								<img src={step2} alt="Step 2: Fill in your details" style={{ flex: 1, minWidth: 0, maxWidth: "305px", height: "auto", display: "block" }} />
								<img src={step3} alt="Step 3: Start banking" style={{ flex: 1, minWidth: 0, maxWidth: "305px", height: "auto", display: "block" }} />
							</div>
						</div>
					</div>

					{/* ── MOBILE layout ── */}
					<div className="hiw-mobile">
						{/* Content positioned within the 342×522 card */}
						<div
							style={{
								position: "absolute",
								top: "40px",
								left: "50%",
								transform: "translateX(-50%)",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								gap: "24px",
							}}
						>
							{/* Label + Heading */}
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									gap: "4px",
									width: "302px",
								}}
							>
								<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
									<span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#86C7A8", flexShrink: 0, display: "inline-block" }} />
									<span
										style={{
											fontFamily: "'Geist Mono', monospace",
											fontWeight: 500,
											fontSize: "14px",
											lineHeight: "32px",
											letterSpacing: "0.08em",
											color: "#86C7A8",
											textTransform: "uppercase",
											whiteSpace: "nowrap",
										}}
									>
										Quick Onboarding
									</span>
								</div>
								<p
									style={{
										...instrumentSerif,
										fontWeight: 400,
										fontSize: "32px",
										lineHeight: "40px",
										color: "#FFFFFF",
										margin: 0,
										textAlign: "center",
										width: "295px",
									}}
								>
									Open your Zikora account in 3 easy steps...
								</p>
							</div>

							{/* Steps row: badges left, text right */}
							<div style={{ display: "flex", gap: "33px", alignItems: "center" }}>
								{/* Badge + connector column */}
								<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
									{STEPS.map((step, i) => (
										<React.Fragment key={step.num}>
											<div
												style={{
													width: "32px",
													height: "32px",
													backgroundColor: "rgba(255,255,255,0.06)",
													borderRadius: "4px",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													flexShrink: 0,
												}}
											>
												<span
													style={{
														fontFamily: "Inter, sans-serif",
														fontWeight: 700,
														fontSize: "14px",
														color: "rgba(238,238,238,0.32)",
														lineHeight: 1,
													}}
												>
													{step.num}
												</span>
											</div>
											{i < STEPS.length - 1 && (
												<div
													style={{
														display: "flex",
														justifyContent: "center",
														width: "32px",
														height: "80px",
													}}
												>
													<div
														style={{
															width: 0,
															height: "80px",
															borderLeft: "2px dashed rgba(255,255,255,0.2)",
														}}
													/>
												</div>
											)}
										</React.Fragment>
									))}
								</div>

								{/* Step text column */}
								<div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
									{STEPS.map((step) => (
										<div
											key={step.num}
											style={{
												display: "flex",
												flexDirection: "column",
												gap: "4px",
												alignItems: "center",
											}}
										>
											<p
												style={{
													fontFamily: "'Geist', sans-serif",
													fontWeight: 500,
													fontSize: "14px",
													lineHeight: "normal",
													color: "#FFFFFF",
													margin: 0,
													whiteSpace: "nowrap",
												}}
											>
												{step.title}
											</p>
											<p
												style={{
													fontFamily: "'Geist', sans-serif",
													fontWeight: 400,
													fontSize: "12px",
													lineHeight: "26px",
													color: "#DEDEDE",
													margin: 0,
													textAlign: "center",
													width: "205px",
												}}
											>
												{step.desc}
											</p>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default HowItWorks;
